import classnames from 'classnames';
import React from 'react';
import { AffiliateIcon } from '../../../components/icons/affiliate-icon';
import { PENSION_DIFFICULTIES } from '../../../helpers/pension-finder/constants';
import styles from '../../../styles/widgets/pension-finder/pension-finder-difficulty.module.scss';

export const Difficulty = React.memo(({ pensionStatus }) => {
  const isPensionFound = pensionStatus === PENSION_DIFFICULTIES.FOUND;
  const iconName = isPensionFound ? 'pf-found' : `pf-difficulty-${pensionStatus}`;

  return (
    <p className={styles.container}>
      <AffiliateIcon className={classnames(styles.icon, styles[pensionStatus])} name={iconName} inline />{' '}
      {isPensionFound ? (
        <span className={styles.label}>
          Pension <strong>{pensionStatus}</strong>
        </span>
      ) : (
        <span className={styles.label}>
          {/*TODO: Fix wording*/}
          This pension will be <strong>{pensionStatus}</strong> to find
        </span>
      )}
    </p>
  );
});
